import { baseApi } from "../baseApi";
import { CartRequest, CartResponse, ProductsResponse } from "./type";

export const burrowApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getProducts: build.query<ProductsResponse, { category?: string; limit?: number } | void>({
      query: (params) => {
        const { category, limit = 500 } = params ?? {};
        return {
          url: "/burrow/products",
          method: "GET",
          params: { limit, category },
        };
      },
      providesTags: ["Products"],
    }),
    getOrders: build.query<
      any,
      { status?: string; limit?: number; page?: number }
    >({
      query: ({ status, limit, page }) => ({
        url: `/burrow/orders`,
        method: "GET",
        params: { status, limit, page },
      }),
      providesTags: ["Orders"],
    }),

    addToCart: build.mutation<CartResponse, CartRequest>({
      query: (body) => ({
        url: "/burrow/cart",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Cart"],
    }),
    getCart: build.query<CartResponse, void>({
      query: () => ({
        url: "/burrow/cart",
        method: "GET",
      }),
      providesTags: ["Cart"],
    }),
    checkout: build.mutation<
      CartResponse,
      { address?: string; city?: string; provinceCode?: string; zipCode?: string }
    >({
      query: (body) => ({
        url: "/burrow/checkout",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Cart", "Orders"],
    }),

    deleteCart: build.mutation<CartResponse, string>({
      query: (id: string) => ({
        url: `/burrow/cart/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Cart"],
    }),
    getProductById: build.query<any, string>({
      query: (id) => ({
        url: `/burrow/products/${id}`,
        method: "GET",
      }),
      providesTags: ["Products"],
    }),
    getGiftCards: build.query<
      any,
      { limit?: number; page?: number } | void
    >({
      query: (params) => {
        const { limit, page } = params ?? {};
        return {
          url: "/burrow/gift-cards",
          method: "GET",
          params: { limit, page },
        };
      },
      providesTags: ["GiftCards"],
    }),
  }),
});

export const {
  useGetProductsQuery,
  useAddToCartMutation,
  useGetCartQuery,
  useCheckoutMutation,
  useDeleteCartMutation,
  useGetProductByIdQuery,
  useGetOrdersQuery,
  useGetGiftCardsQuery,
} = burrowApi;
